import { BaseRepository } from './BaseRepository';
import EventBus from '../services/EventBus';
import { Appointment } from '../models';
import handleResponseError from './utils/handleResponseError';

export type AppointmentParams = {};

export default class AppointmentRepository extends BaseRepository<any> {
  static create(appointment: Appointment) {
    let formData = new FormData();

    for (let [key, value] of Object.entries(appointment.toEntity())) {
      if (Array.isArray(value)) {
        value.forEach((item) => {
          formData.append(`${key}[]`, item);
        });
      } else if (value !== null && typeof value !== 'undefined') {
        formData.append(key, value.toString());
      }
    }

    const requestOptions = {
      method: 'POST',
      headers: {
        // 'Content-Type': 'application/json',
        ...this.authHeader()
      },
      body: formData
    };

    return fetch(`${this.apiUrl}/appointment`, requestOptions)
      .then(this.handleResponse)
      .then(({ data }) => {
        return Appointment.createFromEntity(data);
      });
  }

  static update(appointment: Appointment) {
    const requestOptions = {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
        ...this.authHeader()
      },
      body: JSON.stringify(appointment.toEntity())
    };

    return fetch(`${this.apiUrl}/appointment/${appointment.id}`, requestOptions)
      .then(this.handleResponse)
      .then(({ data }) => {
        return Appointment.createFromEntity(data);
      });
  }

  static checkin(appointments: Appointment[]) {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...this.authHeader()
      },
      body: JSON.stringify({
        ids: appointments.map((appointment) => appointment.id)
      })
    };

    return fetch(`${this.apiUrl}/appointment/checkin`, requestOptions)
      .then(this.handleResponse)
      .then(({ data }) => {
        return data;
      });
  }

  static postOptionalForm(params: {
    appointment: Appointment;
    data: {
      key: string;
      label: string;
      value: any;
    }[];
  }) {
    const requestOptions = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        ...this.authHeader()
      },
      body: JSON.stringify({
        appointment_id: params.appointment.id,
        responses: params.data
      })
    };

    return fetch(`${this.apiUrl}/form-result`, requestOptions)
      .then(this.handleResponse)
      .then(({ data }) => {
        return data;
      });
  }

  static delete(appointment: Appointment) {
    const requestOptions = {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        ...this.authHeader()
      }
    };

    return fetch(`${this.apiUrl}/appointment/${appointment.id}`, requestOptions)
      .then(this.handleResponse)
      .then(({ data }) => {
        EventBus.success('Votre créneau de prise en charge a bien été annulé.');
        return true;
      })
      .catch((e) => {
        return false;
      });
  }

  static handleResponse(response: Response) {
    return response.text().then((text: string) => {
      const res = text && JSON.parse(text);
      if (!response.ok) {
        const error = (res && res.message) || response.statusText;
        let errorString = '';

        if (res.errors) {
          // eslint-disable-next-line @typescript-eslint/no-unused-vars
          for (let [key, value] of Object.entries(res.errors)) {
            errorString += `${value}<br/><br/>`;
          }
        }

        handleResponseError(response, res, errorString || error);

        return Promise.reject(error);
      }

      return res;
    });
  }
}
